function initFreshChat() {
    (window as any).fcWidget.init({
        token: "213491f1-622c-42f4-af6d-6ef417503d4c",
        host: "https://wchat.eu.freshchat.com"
    });
}
function initialize(i: any, t: any) {
    if (i.getElementById(t)) {
        initFreshChat()
    } else {
        var e = i.createElement("script");
        e.id = t;
        e.async = true;
        e.src = "https://wchat.eu.freshchat.com/js/widget.js"
        e.onload = initFreshChat
        i.head.appendChild(e)
    }
}
function initiateCall() {
    initialize(document, "Freshdesk Messaging-js-sdk")
}
export const FreshChat = () => {
    window.addEventListener ? window.addEventListener("load", initiateCall, !1) : (window as any).attachEvent("load", initiateCall, !1);
    return <></>
}